import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/new-logo.png';
import { supabase } from '../../supabaseClient';
import './style.css'; // Inheriting or extending login styles

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    setError('');
    setLoading(true);


    try {
      // Supabase's built-in reset password functionality
      // This will automatically check if the email exists and send the reset link
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${process.env.REACT_APP_FRONTEND_URL}/reset-password`,
      });

      if (error) {
        setError(error.message);
      } else {
        setSubmitted(true);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while sending the reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      <div className="write-section">
        <div className="modal-content">
          <div className="login-logo-container">
            <img src={logo} className="login-logo" alt="Logo" />
          </div>
          <h2>Reset Password</h2>

          {submitted ? (
            <div className="success-message">
              <p style={{ color: "#17324d" }}>If an account exists for <span style={{ color: '#0f5fff' }}>{email}</span>, you will receive a password reset link shortly.</p>
              <button className="login-button" onClick={() => navigate('/login')} style={{ marginTop: '20px' }}>
                Return to Login
              </button>
            </div>
          ) : (
            <>
              <p className="forgot-password-description">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <form onSubmit={handleSubmit} noValidate>
                <label>Email:</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => {
                    setEmail(e.target.value);
                    if (error) setError('');
                  }}
                  placeholder="Email address"
                  className={`login-input ${error ? 'error' : ''}`}
                  required
                />
                {error && <div className="validation-error" >{error}</div>}
                <button type="submit" className="login-button" style={{ marginTop: '10px' }} >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
              <div className="toggle-auth">
                <p>
                  Remember your password?{' '}
                  <span onClick={() => navigate('/login')} style={{ cursor: 'pointer', color: 'var(--primary-color, #007bff)' }}>
                    Sign In
                  </span>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
